import { render, staticRenderFns } from "./PractitionerRegistry.vue?vue&type=template&id=666d1520&scoped=true&"
import script from "./PractitionerRegistry.vue?vue&type=script&lang=js&"
export * from "./PractitionerRegistry.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerRegistry.vue?vue&type=style&index=0&id=666d1520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d1520",
  null
  
)

export default component.exports